import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import Title from 'pages/Words/PageFlip/Title'
import Cover from 'pages/Words/PageFlip/Cover'
import Page from "pages/Words/PageFlip/Page";
import HTMLFlipBook from "react-pageflip";
import { isEmpty, last } from "lodash";
import { BackAndNextButtons, WrapPageFlip } from './Style'
import { ReactComponent as GoIcon } from 'assets/icons/Go.svg';
import { Comment } from "components/Form";
import { IconButton, SvgIcon } from "@mui/material";
import { WordsContext } from "../Words";
import { AnimatePresence, motion } from 'framer-motion';
import { NextButton } from "pages/School/PerformAssessment";
import { useLocation } from "react-router-dom";
import { ArrowForwardIos } from "@mui/icons-material";
import { ReadingProgress } from "..";
import './PageFlipSass.scss'

const CustomBook = (props) => {
    const { pages, title, comment, visibleType } = props
    const { hideDisabledNext, finishPerfom, showCartoon, handleNext } = useContext(WordsContext)
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(Boolean);

    const useMouseEvents = last(pathSegments) == "preview"
    const hideNextButton = useMouseEvents

    const flipBook = useRef()
    const book = useRef()

    const pageCount = book?.current?.pageFlip()?.getPageCount()
    const currentPageIndex = book?.current?.pageFlip()?.getCurrentPageIndex()

    const [currentPage, setCurrentPage] = useState(1)
    const [currentSpread, setCurrentSpread] = useState(pages?.length + 1)
    const [isOpen, setIsOpen] = useState(true);
    const [initialFlag, setInitialFlag] = useState(true);
    const [disabledNext, setDisabledNext] = useState(true)

    const onFlip = useCallback((e) => {
        setIsOpen(prevState => !prevState);
        setCurrentSpread(e.data)
        setInitialFlag(false)
        setDisabledNext(true)
    }, []);

    const handleFlipPrev = () => {
        if (handleNext)
            handleNext()

        else {
            if (currentSpread > 0) {
                book.current.pageFlip().flipPrev();
                setCurrentPage(currentPage => currentPage + 1)
            }
            else
                finishPerfom?.()
        }
    };

    const handleFlipNext = () => {
        setCurrentPage(currentPage => currentPage - 1)
        book.current.pageFlip().flipNext()
    };

    useEffect(() => {
        if (disabledNext)
            setTimeout(() => {
                setDisabledNext(false)
            }, currentSpread == pages?.length + 1 ? 1000 : 2000);
    }, [disabledNext, currentSpread, pages])

    const closed = "closed"
    const open = "open"

    let filpingClass = ""
    if (currentSpread == 0 && initialFlag)
        filpingClass = closed
    else if (currentSpread == pages.length + 1) {
        filpingClass = closed
    }
    else if (currentSpread == 0 && !initialFlag)
        filpingClass = open

    return (
        <WrapPageFlip
            initial={{ opacity: 0.5 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0.5 }}
            transition={{ duration: 0.7 }}
            disabled={showCartoon}>
            {
                !isEmpty(pages) &&
                <React.Fragment>
                    {(
                        !currentSpread &&
                        comment) ?
                        <Comment right={420} title="לחצו על עמודי הספר בכדי לדפדף בין העמודים" open={true} placement={"right"}>
                            <button style={{ background: "transparent", border: "none" }}></button>
                        </Comment>
                        :
                        <></>}

                    {pages.length ?
                        <div className={`book-container ${filpingClass}`} style={{ width: "100%" }}>
                            {currentSpread != pages.length + 1 &&
                                <div className="wrap-prev-button">
                                    <IconButton onClick={handleFlipNext}>
                                        <ArrowForwardIos color="dark" />
                                    </IconButton>
                                </div>
                            }
                            <HTMLFlipBook
                                flippingTime={800}
                                startPage={pages.length + 1}
                                width={203}
                                height={123}
                                autoSize={true}
                                onFlip={onFlip}
                                showPageCorners={false}
                                useMouseEvents={useMouseEvents}
                                swipeDistance={false}
                                // clickEventForward={false}
                                // disableFlipByClick={true}
                                size="stretch"
                                minWidth={200}
                                maxWidth={732}
                                minHeight={120}
                                maxHeight={1020}
                                maxShadowOpacity={0.5}
                                showCover={true}
                                mobileScrollSupport={true}
                                onChangeOrientation={() => { }}
                                className="demo-book"
                                usePortrait
                                ref={book}
                            // ref={(el) => (flipBook.current = el)}
                            >
                                <Cover>
                                    {"סוֹף!"}
                                    {!hideNextButton &&
                                        <div className="wrap-go-prev-page">
                                            <div className="go-prev-page">
                                                <NextButton size="small" action={handleFlipPrev} />
                                            </div>
                                        </div>}
                                </Cover>

                                {pages?.map((page, index) =>
                                    <Page hideNextButton={hideNextButton} visibleType={visibleType} disabledNext={hideDisabledNext ? false : disabledNext} currentPage={currentSpread} handleFlipPrev={handleFlipPrev} key={index} number={pages.length - index} firstPage={index == pages.length - 1} title={title}>
                                        {page.map((word) =>
                                            word
                                        )}
                                    </Page>
                                )}

                                <Cover firstPage currentPage={currentSpread} handleFlipPrev={handleFlipPrev}>
                                    <Title>
                                        {title}
                                    </Title>
                                    {!hideNextButton &&
                                        <div className="wrap-go-prev-page">
                                            <div className="go-prev-page">
                                                <NextButton size={"small"} disabled={hideDisabledNext ? false : disabledNext} action={handleFlipPrev} />
                                            </div>
                                        </div>}
                                </Cover>
                            </HTMLFlipBook>
                        </div>
                        : null}
                </React.Fragment>
            }
            {hideNextButton ||
                <ReadingProgress
                    pagesReadCount={currentPage}
                    totalPagesCount={Math.floor(((pages?.length + 1) / 2) + 2)}
                />}
        </WrapPageFlip >
    )
}

export default CustomBook

